'use strict';

var jsxRuntime = require('react/jsx-runtime');
var codeBaseFeatureDefinitions = require('./codeBaseFeatureDefinitions.cjs');
var CodeBaseFeatureFlagsContext = require('./CodeBaseFeatureFlagsContext.cjs');

const CodeBaseFeatureFlagsProvider = ({ children, configurations }) => {
  const getCodeBaseFeature = (codeBaseFeatureKey, identifier) => {
    return codeBaseFeatureDefinitions.getCodeBaseFeatureFlag(
      configurations,
      codeBaseFeatureKey,
      identifier
    );
  };
  return /* @__PURE__ */ jsxRuntime.jsx(CodeBaseFeatureFlagsContext.Provider, { value: { getCodeBaseFeature }, children });
};

module.exports = CodeBaseFeatureFlagsProvider;
//# sourceMappingURL=CodeBaseFeatureFlagsProvider.cjs.map
